module.exports = __webpack_public_path__ + "media/images/icn-blog-4640d61f.png";